module.exports = __webpack_public_path__ + "static/media/expense_graphic.76f5c9eb.svg";